import { PatientConversationAttachmentDTO } from "@vitable/asclepius-api-client-ts"
import { SERVER_URL } from "@/config"

// TDP §5.2.3; the server enforces the same limits
export const MAX_ATTACHMENTS_PER_MESSAGE = 5
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024
export const ALLOWED_ATTACHMENT_TYPES: ReadonlyArray<string> = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/pdf"
]
export const ATTACHMENT_ACCEPT = ALLOWED_ATTACHMENT_TYPES.join(",")

export function isImageAttachment(attachment: Pick<PatientConversationAttachmentDTO, "content_type">): boolean {
  return attachment.content_type.startsWith("image/")
}

/** Production URLs are signed and absolute; local development serves `/media/…` from the API host. */
export function resolveAttachmentUrl(downloadUrl: string): string {
  return downloadUrl.startsWith("/") ? `${SERVER_URL}${downloadUrl}` : downloadUrl
}

/** Why a chosen file cannot be attached, before any upload; `undefined` when it can. */
export function describeRejectedFile(file: File): string | undefined {
  if (!ALLOWED_ATTACHMENT_TYPES.includes(file.type)) return `${file.name}: only JPEG, PNG, WebP images and PDFs`
  if (file.size > MAX_ATTACHMENT_BYTES) return `${file.name}: files must be 10 MB or smaller`
  return undefined
}
